
import Vue from 'vue'
// 自定义国际化配置
import VueI18n from 'vue-i18n'
import dbHelper from '../util/db'

// 本地语言包
import zhLocale from './zh'
import enLocale from './en'

if (process.env.NODE_ENV === 'development') {
  console.log('调试代码')
}

Vue.use(VueI18n)

const messages = {
  zh: {
    ...zhLocale,
  },
  en: {
    ...enLocale,
  }
}

/**
 * 获取当前系统使用语言字符串
 *
 * @returns zh|en ...
 */
export function getLanguage() {
  // 本地缓存获取
  let language = dbHelper.get('language')
  if (language) {
    return language
  }

  // 浏览器使用语言
  language = navigator.language.toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'zh'
}

const i18n = new VueI18n({
  legacy: false,
  locale: getLanguage(),
  messages: messages
})

export default i18n
